import dayjs from 'dayjs';

import type { Dayjs } from 'dayjs';

export type DateInput = string | number | Date | Dayjs | null | undefined;

export const formatDate = (date: DateInput, format: string): string | null =>
  date ? dayjs(date).format(format) : null;
